import React from 'react';
import PropTypes from 'prop-types';
import AddressFieldItem, { addressFieldProp } from './AddressFieldItem';
import { getValidationSchema } from '../../../tools/validations/address';

const propTypes = {
  fields: PropTypes.arrayOf(addressFieldProp).isRequired,
  countryCode: PropTypes.string.isRequired,
  errorTmnts: PropTypes.shape({}),
};

export default function AddressFields(props) {
  const {
    fields, countryCode, errorTmnts,
  } = props;

  const validationSchema = getValidationSchema(countryCode);

  return fields.map((field) => (
    <AddressFieldItem
      key={`FIELD_${field.name}`}
      field={field}
      validateFn={validationSchema[field.validationRule]}
      errorTmnts={errorTmnts}
    />
  ));
}

AddressFields.propTypes = propTypes;
AddressFields.defaultProps = {
  addressFormData: undefined,
  errorTmnts: undefined,
};
